/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */

import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';
import { HttpError, PMSError, ValidationError } from '@/errors';

const endpoint = `${apiEndpoint}/connectivity/booking-engine`;

const state = {
  pending: null,
  updatePending: false,
  updateError: null,
  paymentGateways: [],
  paymentGateway: [],
  easebuzzGateway: null,
  easebuzzGatewayPending: null,
  easebuzzGatewayUpdatePending: null,
};

const getters = {
  paymentGateways: (state) => state.paymentGateways,
  pending: (state) => state.pending,
  updatePending: (state) => state.updatePending,
  updateError: (state) => state.updateError,
  easebuzzGateway: (state) => state.easebuzzGateway,
  easebuzzGatewayPending: (state) => state.easebuzzGatewayPending,
  easebuzzGatewayUpdatePending: (state) => state.easebuzzGatewayUpdatePending,
};

const mutations = {
  clearErrors() {
    // do nothing
  },
  beforeRequest(state) {
    state.updateError = null;
    state.pending = true;
  },
  beforeUpdate(state) {
    state.updateError = null;
    state.updatePending = true;
  },
  afterUpdate(state, error = null) {
    state.updatePending = false;
    state.updateError = error;
  },
  setPaymentGateways(state, data) {
    state.paymentGateways = data;
    state.pending = false;
  },
  setEasebuzzGateway(state, data) {
    state.easebuzzGateway = data;
    state.easebuzzGatewayPending = false;
  },
  beforeEasebuzzUpdate(state) {
    state.updateError = null;
    state.easebuzzGatewayUpdatePending = true;
  },
  afterEasebuzzUpdate(state, error = null) {
    state.easebuzzGatewayUpdatePending = false;
    state.updateError = error;
  },
  beforeEasebuzzRequest(state) {
    state.updateError = null;
    state.easebuzzGatewayPending = true;
  },
};

function handleApiError(commit, error) {
  const { status, data } = error.response;
  let err = error;
  switch (status) {
    case 400: // BadRequest
      err = new HttpError(status, data.message);
      break;
    case 409: // PMSError
      err = new PMSError(status, data.message);
      break;
    case 422:
      err = new ValidationError(status, data.message, data.errors);
      break;
    case 500:
      err = new Error(data.message);
      break;
    default:
      break;
  }
  // commit('update', err);
  throw err;
}

const actions = {
  async fetchPaymentPayments({ commit }) {
    try {
      commit('beforeRequest');
      const { data } = await ApiService.get(`${endpoint}/pci-payment-gateway`);
      commit('setPaymentGateways', data);
    } catch (error) {
      handleApiError(commit, error);
    }
  },
  async updatePaymentGateway({ commit }, payload) {
    commit('beforeUpdate');
    try {
      const { data } = await ApiService.post(`${endpoint}/pci-payment-gateway`, payload);
      return data;
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterUpdate');
    }
  },
  async getEasebuzzPaymentGateway({ commit }) {
    commit('beforeEasebuzzRequest');
    try {
      const { data } = await ApiService.get(`${endpoint}/easebuzz-payment-gateway`);
      commit('setEasebuzzGateway', data);
      return data;
    } catch (error) {
      throw handleApiError(commit, error);
    }
  },
  async deleteEasebuzzPaymentGateway({ commit }) {
    commit('beforeEasebuzzUpdate');
    try {
      await ApiService.delete(`${endpoint}/easebuzz-payment-gateway`);
      commit('setEasebuzzGateway', null);
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterEasebuzzUpdate');
    }
  },
  async updateEasebuzzPaymentGateway({ commit }, payload) {
    commit('beforeEasebuzzUpdate');
    try {
      const { data } = await ApiService.post(`${endpoint}/easebuzz-payment-gateway`, payload);
      commit('setEasebuzzGateway', data);
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterEasebuzzUpdate');
    }
  },
  async deletePaymentGateway({ commit }, gateway) {
    commit('beforeUpdate');
    try {
      const { data } = await ApiService.delete(`${endpoint}/pci-payment-gateway/${gateway}`);
      return data;
    } catch (error) {
      throw handleApiError(commit, error);
    } finally {
      commit('afterUpdate');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
